import { PaymentType } from '@/types/payment';
import { PaymentGroupType } from '@/types/payment-groups';
import { usePaymentsList } from '../../hooks/usePaymentsList';
import { PaymentPageTab } from '../../types';
import { PaymentsListContent } from '../PaymentsListContent';

type ListPaymentsToReceiveProps = {
  paymentGroupType?: PaymentGroupType;
  paymentType?: PaymentType;
};

export function ListPaymentsToReceive({
  paymentGroupType,
  paymentType,
}: ListPaymentsToReceiveProps) {
  const paymentsListData = usePaymentsList({
    paymentGroupType,
    paymentType,
    tab: PaymentPageTab.TO_RECEIVE,
  });

  return (
    <PaymentsListContent
      {...paymentsListData}
      tab={PaymentPageTab.TO_RECEIVE}
    />
  );
}
